type NumericSeries = Array<number | null>;

/**
 * Returns the interpolated series value at the given axis position.
 */
export const getSeriesValueAtAxis = (
    series: NumericSeries,
    axisValue: number,
    axisScale: number
): number | null => {
    if (!Array.isArray(series) || series.length === 0) return null;
    if (!Number.isFinite(axisValue) || axisValue < 0) return null;
    if (!Number.isFinite(axisScale) || axisScale <= 0) return null;

    const normalizedAxisValue = axisValue / axisScale;
    if (!Number.isFinite(normalizedAxisValue) || normalizedAxisValue < 0) return null;

    const lowerIndex = Math.floor(normalizedAxisValue);
    if (lowerIndex >= series.length) return null;

    const lowerValue = series[lowerIndex] ?? null;
    const upperIndex = Math.ceil(normalizedAxisValue);

    if (upperIndex <= lowerIndex) {
        return lowerValue;
    }

    if (upperIndex >= series.length) {
        return lowerValue;
    }

    const upperValue = series[upperIndex] ?? null;
    if (lowerValue === null && upperValue === null) return null;

    if (lowerValue !== null && upperValue !== null) {
        const ratio = normalizedAxisValue - lowerIndex;
        return lowerValue + (upperValue - lowerValue) * ratio;
    }

    return lowerValue ?? upperValue;
};
